import { FDealType, FOfferType, isAvailable } from 'shared/common/packages/JsonQuery';

import { DatesContainer } from '../../containers/filters/DatesContainer';
import { IFilter } from '../../types/filters';

export const dates: IFilter = {
  availability: isAvailable(FDealType.RentDaily, FOfferType.Any),
  component: DatesContainer,
};
